import React from "react";
import withStyles from "react-jss";

const styles = (theme) => {
	return {
		root: {},
		header: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			paddingBottom: "65px",
		},
		headerMain: {
			fontFamily: theme.fonts.bold,
			fontSize: "24px",
			lineHeight: 0.75,
			color: theme.palette.colors.addressBlackHeader,
		},
		headerSecondary: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: 1,
			letterSpacing: "2.3px",
			color: theme.palette.colors.purplishBlue,
			textTransform: "uppercase",
		},
		list: {
			display: "flex",
			justifyContent: "flex-start",
			alignItems: "flex-start",
			flexWrap: "wrap",
			marginRight: "-20px",
		},
		col: {
			width: "100%",
			marginBottom: "45px",
		},
		colHeader: {
			fontFamily: theme.fonts.bold,
			fontSize: "16px",
			lineHeight: 1,
			color: theme.palette.colors.darkSlateBlue,
			marginBottom: "21px",
		},
		colItem: {
			"& a, & span": {
				fontFamily: theme.fonts.medium,
				fontSize: "14px",
				lineHeight: 1.71,
				color: theme.palette.colors.oneMoreGrey,
				textOverflow: "ellipsis",
				overflow: "hidden",
			},
		},
		alphabet: {
			display: "flex",
			justifyContent: "flex-start",
			alignItems: "flex-start",
			marginRight: "-20px",
		},
		alphabetCol: {
			width: "100%",
			marginRight: "20px",
			marginBottom: 0,
			"&:last-child": {
				marginRight: 0,
			},
		},
		alphabetBlock: {
			width: "100%",
			position: "relative",
			marginBottom: "24px",
			paddingLeft: "30px",
		},
		alphabetColHeader: {
			position: "absolute",
			top: "4px",
			left: 0,
			fontFamily: theme.fonts.bold,
			fontSize: "14px",
			lineHeight: 1.14,
			color: theme.palette.colors.darkSlateBlue,
		},
		alphabetColItem: {
			"& a, & span": {
				fontFamily: theme.fonts.medium,
				fontSize: "14px",
				lineHeight: 1.71,
				color: theme.palette.colors.oneMoreGrey,
				textOverflow: "ellipsis",
				overflow: "hidden",
			},
		},
		[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
		[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
			list: {
				marginRight: 0,
			},
			col: {
				width: "100%",
				marginBottom: "45px",
				marginRight: "auto",
				display: "flex",
				flexWrap: "wrap",
				alignItems: "center",
			},
			colHeader: {
				fontSize: "14px",
				lineHeight: 1.14,
				marginBottom: "11px",
				width: "100%",
			},
			colItem: {},
			alphabet: {
				marginRight: 0,
			},
			alphabetCol: {
				width: "100%",
				marginBottom: 0,
				marginRight: "50px",
			},
		},
		[`@media (max-width: ${theme.media.sm})`]: {
			header: {
				paddingBottom: "33px",
				alignItems: "flex-start",
			},
			headerMain: {
				fontSize: "18px",
				lineHeight: 1,
			},
			headerSecondary: {
				fontSize: "14px",
				lineHeight: 1.14,
				letterSpacing: "2px",
				marginLeft: "30px",
				flexShrink: 0,
				marginTop: "2px",
			},
			list: {
				marginRight: 0,
			},
			col: {
				width: "100%",
				marginBottom: "33px",
				marginRight: 0,
				display: "flex",
				flexWrap: "wrap",
				alignItems: "center",
			},
			colHeader: {
				width: "100%",
			},
			colItem: {
				width: "100%",
			},
			alphabet: {
				marginRight: 0,
			},
			alphabetCol: {
				width: "100%",
				marginBottom: 0,
				marginRight: 0,
			},
		},
	};
};

class List extends React.PureComponent {
	generateAlphabetical = () => {
		let {
			defaultItems,
			windowSizes: { lg, md, sm, xs },
		} = this.props;
		let classes = this.props.classes;

		function toNextColumn() {
			if (objectsInBlock.length) {
				blockInColumns.push(
					<div key={blocksCounter} className={classes.alphabetBlock}>
						<div className={classes.alphabetColHeader}>{blockLetter}</div>
						{objectsInBlock}
					</div>
				);
			}

			blocksCounter = 0;
			columns.push(
				<div key={columnsCounter} className={classes.alphabetCol}>
					{blockInColumns}
				</div>
			);

			columnsCounter++;

			currentHeight = 0;
			objectsInBlock = [];
			blockInColumns = [];
		}

		function toNextBlock() {
			blockInColumns.push(
				<div key={blocksCounter} className={classes.alphabetBlock}>
					<div className={classes.alphabetColHeader}>{blockLetter}</div>
					{objectsInBlock}
				</div>
			);
			currentHeight += defaultBlockMargin;
			blocksCounter++;
			objectsInBlock = [];
		}

		let columns = [];
		let columnsCounter = 0;
		let blockInColumns = [];
		let blocksCounter = 0;
		let objectsInBlock = [];
		let currentHeight = 0;
		let maxHeight = 720;
		if (md || sm) maxHeight = 890;
		if (xs) maxHeight = Number.POSITIVE_INFINITY;
		let itemHeight = 24;
		let defaultBlockMargin = 24;
		let blockLetter = defaultItems[0].name.substring(0, 1);
		let testHeight = 0;
		if (lg || md || sm) {
			for (var i = 0; i < defaultItems.length; i++) {
				if (defaultItems[i].name.substring(0, 1) !== blockLetter) {
					testHeight += defaultBlockMargin;
					blockLetter = defaultItems[i].name.substring(0, 1);
				}
				testHeight += itemHeight;
			}
			if (lg || md) {
				maxHeight = testHeight / 5 + itemHeight;
			} else {
				maxHeight = testHeight / 3 + itemHeight;
			}
		}
		blockLetter = defaultItems[0].name.substring(0, 1);
		for (var i = 0; i < defaultItems.length; i++) {
			let item = defaultItems[i];

			if (item.name.substring(0, 1) !== blockLetter) {
				toNextBlock();
				i--;
				blockLetter = item.name.substring(0, 1);
				continue;
			}
			if (currentHeight + itemHeight <= maxHeight) {
				if (!!this.props.quality.length) {
					let idxOfEmpty = item.name.lastIndexOf(" ");
					if (item.name.substr(idxOfEmpty + 1) !== "sd") {
						objectsInBlock.push(
							<div key={i} className={classes.alphabetColItem}>
								<span>
									{item.name.substr(0, idxOfEmpty)}
									<span style={{ color: "#2b1d5d" }}>{` ${item.name
										.substr(idxOfEmpty + 1)
										.charAt(0)
										.toUpperCase()}${item.name.substr(idxOfEmpty + 2)}`}</span>
								</span>
							</div>
						);
					} else {
						objectsInBlock.push(
							<div key={i} className={classes.alphabetColItem}>
								<span>{item.name.substr(0, idxOfEmpty)}</span>
							</div>
						);
					}
				} else {
					let quality = [];
					item.quality.map((elem) => {
						if (elem.name !== "sd") {
							quality.push(`${elem.name.charAt(0).toUpperCase()}${elem.name.substr(1)}`);
						}
					});
					objectsInBlock.push(
						<div key={i} className={classes.alphabetColItem}>
							<span>
								{item.name} <span style={{ color: "#2b1d5d" }}>{quality.join(" ")}</span>
							</span>
						</div>
					);
				}
				currentHeight += itemHeight;
				if (i == defaultItems.length - 1) {
					toNextColumn();
				}
			} else {
				toNextColumn();
				i--;
			}
		}
		return columns;
	};

	render() {
		let { defaultItems } = this.props;
		let classes = this.props.classes;

		if (!defaultItems.length) {
			return null;
		}
		return (
			<div className={classes.root}>
				<div className={classes.alphabet}>{this.generateAlphabetical()}</div>
			</div>
		);
	}
}

export default withStyles(styles)(List);
